import isHotKey from 'is-hotkey';
import { placeholderInSelection, deleteAndSetMarks } from '..';
var MODIFIERS_CODE = ['alt', 'control', 'meta', 'shift'];
var MODIFIERS = 'mod?+alt?+shift?+ctrl?';
var isBackwardNavigationHotKey = isHotKey(["".concat(MODIFIERS, "+up"), "".concat(MODIFIERS, "+left")]);
var isForwardNavigationHotKey = isHotKey(["".concat(MODIFIERS, "+down"), "".concat(MODIFIERS, "+right")]);
var isNavigationHotKey = isHotKey(["".concat(MODIFIERS, "+up"), "".concat(MODIFIERS, "+left"), "".concat(MODIFIERS, "+down"), "".concat(MODIFIERS, "+right")]);
export default function makeOnKeyDown(_ref) {
  var store = _ref.store;
  return {
    onKeyDown: function onKeyDown(event, editor, next) {
      var placeholder = placeholderInSelection(editor, store); // Helpers for onChange navigation around the placeholder

      if (isBackwardNavigationHotKey(event)) {
        store.updateItem('isForward', false);
      } else if (isForwardNavigationHotKey(event)) {
        store.updateItem('isForward', true); // The placeholder can be selected but we still don't want to be able to navigate right

        if (placeholder && !placeholder.edition && isHotKey('shift?+right', event)) {
          event.preventDefault();
          var isSelecting = isHotKey('shift+right', event);
          return editor["move".concat(isSelecting ? 'End' : '', "ToEndOfInline")]();
        }
      }

      if (editor.value.selection.isUnset || !placeholder) return next(); // In edition, enter leave the placeholder, all other keys should not have further effects in other plugins

      if (placeholder.edition) {
        if (isHotKey('enter', event) || isHotKey('escape', event)) {
          return editor.command('deselectPlaceholder', placeholder.key).moveToEndOfInline();
        } else if (!isHotKey('backspace', event)) {
          return editor;
        }
      } else if (placeholder.selected && !event.metaKey && !MODIFIERS_CODE.includes(event.key.toLowerCase()) && !isNavigationHotKey(event)) {
        // When selecting, any non-navigation-keys should replace the placeholder mathing it's style
        deleteAndSetMarks(editor, placeholder.key);
      }

      return next();
    }
  };
}